import * as t from 'io-ts';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';
import { createLocalStorageItem } from '../createLocalStorageItem';
import { LocalStorageItemState } from '../LocalStorageItemState';

const decodeIO = t.boolean;

const decode = buildValidator('localStorageStreamBanner.decodeIO', decodeIO, true);

export const localStorageAnniversaryInfo = (withAutorun: boolean, key: string): LocalStorageItemState<boolean> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: false
    });
};

